import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import AuthContext from '../modules/contexts/Auth';
import * as PATH from '../lib/routes/path';
import { isProductionEnv } from '../lib/util/Environment';

class NaverCallbackPage extends Component {
  static contextType = AuthContext;
  componentDidMount() {
    console.log('=== 네이버 공식 문서 방식으로 콜백 처리 ===');
    console.log('1. 현재 URL:', window.location.href);
    console.log('2. URL 파라미터:', window.location.search);
    
    // 공식 문서 방식: URL 파라미터에서 code와 state 직접 추출
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const state = urlParams.get('state');
    const error = urlParams.get('error');
    const errorDescription = urlParams.get('error_description');
    
    console.log('3. 추출된 파라미터:');
    console.log('   - code:', code);
    console.log('   - state:', state);
    console.log('   - error:', error);
    console.log('   - error_description:', errorDescription);
    
    // 에러 처리 (공식 문서 3.4.3)
    if (error) {
      console.error('네이버 로그인 에러:', error, errorDescription);
      alert(`네이버 로그인 에러: ${errorDescription}`);
      window.location.replace(PATH.SIGNIN);
      return;
    }
    
    // code가 없으면 에러 (공식 문서 3.4.3)
    if (!code) {
      console.error('네이버 인증 코드가 없습니다.');
      console.log('URL 파라미터 상세:', window.location.search);
      alert('네이버 인증 코드가 없습니다. 다시 로그인해주세요.');
      window.location.replace(PATH.SIGNIN);
          return;
        }
    
    console.log('4. 네이버 인증 성공 - 프론트엔드에서 토큰 교환');
    
    // 공식 문서 방식: 프론트엔드에서 네이버 API 호출하여 access_token 발급
    this.exchangeCodeForToken({ code, state });
  }

  // 공식 문서 3.4.4: 백엔드에서 네이버 토큰 교환 API 호출
  exchangeCodeForToken = ({ code, state }) => {
    console.log('5. 백엔드로 네이버 인증 코드 전송:', code);
    console.log('6. State 토큰:', state);
    
    // 백엔드에서 네이버 API 호출하여 토큰 교환 처리
    // 공식 문서 3.4.4: https://nid.naver.com/oauth2.0/token API 호출
    this.context.actions.signinNaverWithCode({ code, state });
  }

  render() {
    return (
      <>
        {this.context.state.logged && (
          <>
            {sessionStorage.nPrevUrl ? (
              <Redirect to={sessionStorage.nPrevUrl} />
            ) : (
              <Redirect to={PATH.HOME} />
            )}
          </>
        )}
        <div />
      </>
    );
  }
}

export default NaverCallbackPage;
